import { withNamespaces } from 'react-i18next';
import { Button } from 'reactstrap';

const MessageReply = ({
    t,
    disabled = false,
    onReply,
}) => (
    <Button
        type="button"
        className="mailbox-message-detail__reply"
        disabled={disabled}
        onClick={onReply}
    >
        {t('Reply')}
    </Button>
);

export default withNamespaces()(MessageReply);
